(function ($) {
    $(() => {

        var plusContentShowed = false;
        var lastScrollTop = 0, delta = 5;


        if ($(".js-mh-product-title").length) {
            $(".js-mh-product-title").matchHeight({
                byRow: true
            });
        }



        if ($(".js-mh-price").length) {
            $(".js-mh-price").matchHeight({
                byRow: true
            });
        }


        if ($(".js-mh-price-old").length) {
            $(".js-mh-price-old").matchHeight({
                byRow: true
            });
        }


        if ($(".js-mh-card-news").length) {
            $(".js-mh-card-news").matchHeight({
                byRow: true
            });
        }



        $('.js-filter-toggle').on('click', function (e) {
            e.preventDefault();
            $('.js-filter-toggle-wrapper').slideToggle();
        })


        $('.js-sidebar').stickySidebar({
            topSpacing: $('.navbar').outerHeight(),
            bottomSpacing: 0,
            containerSelector: '.sidebar__container',
            innerWrapperSelector: '.plus-sidebar-wrapper',
            resizeSensor: true,
            minWidth: 992,
        });



        if ($('.js-product-slider').length) {

            var productSliderThumbs = new Swiper(".js-product-slider-thumbs", {
                loop: false,
                spaceBetween: 20,
                slidesPerView: "auto",
                freeMode: false,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                centeredSlides: true,

            });

            var productSlider = new Swiper(".js-product-slider", {
                loop: false,
                spaceBetween: 11,
                effect: "fade",
                thumbs: {
                    swiper: productSliderThumbs,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            });
        }


        if ($('.js-popular-products').length) {
            var popularProducts = new Swiper(".js-popular-products", {
                slidesPerView: 1,
                spaceBetween: 20,
                navigation: {
                    nextEl: ".js-popular-products-next",
                    prevEl: ".js-popular-products-prev",
                },
                breakpoints: {
                    520: {
                        slidesPerView: 2,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    992: {
                        slidesPerView: 3,
                    },
                    1200: {
                        slidesPerView: 4,
                    },
                },


            });

        }



        $('.navbar a').click(function (e) {
            let link = $(this).attr('href');
            if (link == '#rolunk' && window.location.pathname == '/') {
                console.log('nyitólap');
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: $('#rolunk').offset().top
                }, 1000);
            }
            if (link == '#rolunk' && window.location.pathname != '/') {
                console.log('aloldal');
                window.location.href = '/#rolunk';
            }
        });

        if (window.location.hash == '#rolunk' && window.location.pathname == '/') {
            $('html, body').animate({
                scrollTop: $('#rolunk').offset().top
            }, 1000);
        }

        if ($('.fullpage').length > 0) {
            const yplayer = document.querySelector('.trigger-element');
            let videoObserver = new IntersectionObserver(entries => {
                $.each(entries, (i, entry) => {

                    if (entry.intersectionRatio > 0) {
                        $('.navbar').addClass('is-scrolled');
                    } else {
                        $('.navbar').removeClass('is-scrolled');
                    }
                });
            });
            videoObserver.observe(yplayer);
        }

        $('.js-hover-img').mouseover(function () {
            const src = $(this).data('hover');
            $(this).attr('src', src);
        }).mouseleave(function () {
            const src = $(this).data('default');
            $(this).attr('src', src);
        });

        $(window).scroll(function () {
            if ($(window).scrollTop() > 0 && $('.fullpage').length == 0) {
                $('.navbar').addClass('is-scrolled');
            } else {
                $('.navbar').removeClass('is-scrolled');
            }

            if ($('.tabla-container').length > 0) {
                if ($(window).scrollTop() > $('.tabla-container').offset().top + ($('.tabla-container').height() / 2)) {
                    $('.navbar-brand--frontpage').addClass('is-scrolled');
                } else {
                    $('.navbar-brand--frontpage').removeClass('is-scrolled');
                }

            }

        });

        $('.navbar-toggler').click(function () {
            $('.navbar-collapse').toggleClass('is-opened');
            $('.navbar').toggleClass('is-opened');
        });

        $('.js-to-top').click(function () {
            $('html, body').animate({
                scrollTop: 0
            }, 1500);
        });

        $('.js-next-section').click(function () {
            let next = $(this).parents('.cover').next('.band').offset().top - 120;
            $('html, body').animate({
                scrollTop: next
            }, 500);
        });

    });
})(jQuery);
